module.exports = __webpack_public_path__ + "assets/img/eyes-attack.f6c20afc.png";